import { h, app } from 'hyperapp';
import Axios from 'axios';
import './templateListModule.less';
import { ddState, ddActions, Dropdown } from '../../../../../common/components/dropdown/dropdown';
import { Pagination } from '../../../../../common/components/pagination/pagination';
import { PAGE_SIZE } from '../../../../../common/constants';
import { resolutionState, resolutionActions, Desktop } from '../../../../../utils/resizeObserver';
import { makeUrl } from '../../../../../utils/makeUrl';
import { uniqueArray } from '../../../../../utils/uniqueArray';
import { isNotDesktop } from '../../../../../utils/isNotDesktop';
import { addToCartRequest } from '../../../utils/addToCartRequest';
import { GlobalNotification } from '../../../../../common/components/global-notification/global-notification';
import { getProductData } from '../../../utils/data';
import { readPagination } from '../../../utils/readPagination';
import {
    appendShowMore,
    removeShowMore,
} from '../../../../../common/components/show-more/show-more';
import {
    fdState,
    fdActions,
    FiltersDropdown,
} from '../../../../../common/components/filtersDropdown/filtersDropdown';
import { updateMiniCart } from '../../../utils/updateMiniCart';
import { resolveUrl } from '../../../../../utils/resolveUrl';
import { onScroll } from '../../../../../utils/on-scroll';
import { ADD_TO_CART, DOWNLOAD, PURCHASE_CD } from '../../../asyncPriceBlock/availabilityOptions';

const WEBDATA = {
    NOT_ASKED: 'not_asked',
    LOADING: 'loading',
    ADDED: 'added',
};

export const loadOptionsForSku = async (sku, siteId) => {
    try {
        const { data: response } = await Axios.get(
            makeUrl(
                `/rest/model/schneider/catalog/CatalogLookupActor/getSkuOptions?skuId=${sku}&pushSite=${siteId}`
            )
        );
        if (response.success === 'false') {
            return [];
        }
        return response.options || [];
    } catch (error) {
        return [];
    }
};

export const removeTab = tab => {
    if (tab) {
        tab.parentElement.removeChild(tab);
        const tabHeaderItem = document.querySelector(`button[data-tab=${tab.id}]`).parentElement;
        tabHeaderItem.parentElement.removeChild(tabHeaderItem);
    }
};

let miniIDindex = 0;

export default async (data, el, scrollToCurrentTab) => {
    /**
     * @typedef {Object} OptionItem
     * @property {string} productDisplayName
     * @property {string} description
     * @property {string} skuId
     * @property {string} productId
     * @property {string} category
     * @property {string} subCategory
     * @property {string} imageUrl
     * @property {string} listPrice
     * @property {string | null} salePrice
     * @property {boolean} unavailable
     * @property {boolean} howToBuy
     * @property {string} productPageUrl
     * @property {string | null} partnerDisplayName
     * @property {string} status
     * @property {boolean} priceWithVAT
     * @property {string} partNum
     * @property {boolean} defaultImage
     * @property {string} homeLink
     */

    const tabName = el.id;
    // eslint-disable-next-line
    const miniID = () => `${tabName}-key-${miniIDindex++}`;
    el.classList.remove('pd-tabs__tab_hidden');

    const rootElement = document.getElementById(`${tabName}-container`);

    if (!rootElement) {
        throw new Error('There is no root element for options');
    }
    function extractCategories(list) {
        const getAllSubCategoriesFirstElement = () => ({
            key: miniID(),
            title: getProductData().allSubCategories,
            categoryTag: 'All-Sub-Categories',
        });
        const sortAlphabetically = (a, b) =>
            a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
        const getSubCategories = categoryTitle => {
            const subCategoriesList = uniqueArray(
                list.filter(item => item.category === categoryTitle).map(item => item.subCategory)
            )
                .map(title => ({
                    title,
                    key: miniID(),
                    categoryTag: list.find(
                        item => item.category === categoryTitle && item.subCategory === title
                    ).subCategoryTag,
                }))
                .sort(sortAlphabetically);
            return subCategoriesList.length === 1
                ? subCategoriesList
                : [getAllSubCategoriesFirstElement(), ...subCategoriesList];
        };
        // eslint-disable-next-line
        let categories = [...new Set(list.map(item => item.category))]
            .map(title => ({
                title,
                categoryTag: list.find(item => item.category === title).categoryTag,
                key: miniID(),
                subCategories: getSubCategories(title),
            }))
            .sort(sortAlphabetically);
        if (categories.length > 1) {
            categories.unshift({
                key: miniID(),
                title: getProductData().allCategory,
                categoryTag: 'All-categories',
            });
        }
        return categories;
    }
    const categories = extractCategories(data);

    const initialState = {
        data: data.map(p => ({
            ...p,
            status: WEBDATA.NOT_ASKED,
            productPageUrl: resolveUrl(p.productPageUrl),
        })),
        allCategoriesDD: { ...ddState },
        filterDropdown: { ...fdState },
        categories,
        allSubCategoriesDD: { ...ddState },
        currentPage: 1,
        ...resolutionState,
        loadImages: false,
    };
    const dataProduct = getProductData();
    const initialActions = {
        addToCart: product => async (state, action) => {
            action.changeProductStatus({ product, status: WEBDATA.LOADING });
            const orderResponse = await addToCartRequest({
                productId: product.productId,
                skuId: product.skuId,
                quantity: 1,
            });
            if (!orderResponse.success) {
                const gError = new GlobalNotification('error');
                gError.show(orderResponse.msg, document.querySelector('.main-wrapper'));
                action.changeProductStatus({ product, status: WEBDATA.NOT_ASKED });
            } else {
                updateMiniCart(orderResponse.total);
                action.changeProductStatus({ product, status: WEBDATA.ADDED });
            }
        },

        changeProductStatus: ({ product, status }) => state => {
            const updatedData = state.data.map(p => {
                if (p.skuId === product.skuId) {
                    return { ...product, status };
                }
                return p;
            });

            return { ...state, data: updatedData };
        },
        changeProductsData: mapUpdatedProducts => state => {
            const updatedData = state.data.map(product => {
                const updatingProduct = mapUpdatedProducts[product.partNum];
                if (updatingProduct) {
                    return updatingProduct;
                }
                return product;
            });
            return { ...state, data: updatedData };
        },

        allCategoriesDD: {
            ...ddActions,
        },
        allSubCategoriesDD: {
            ...ddActions,
        },
        filterDropdown: {
            ...fdActions,
        },
        setCurrentPage: ({ value = 1, shouldBeScrolled = false }) => state => {
            if (shouldBeScrolled) {
                scrollToCurrentTab();
            }
            return { ...state, currentPage: value };
        },
        loadPriceCurrentProducts: currentProducts => (state, actions) => {
            const toLoadPricesFor = currentProducts.filter(item => !item.queryIsSended);
            if (toLoadPricesFor.length === 0) return;
            const mapProductsSend = toLoadPricesFor.reduce((queriesSended, item) => {
                item.queryIsSended = true;
                queriesSended[item.partNum] = item;
                return queriesSended;
            }, {});
            actions.changeProductsData(mapProductsSend);
            const partsNumbers = toLoadPricesFor.map(item => item.partNum);
            Axios.get(
                makeUrl(
                    `/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/optionTabAvailabilityInfo?partNumbersList=${partsNumbers.join(
                        '%7C'
                    )}&pushSite=${dataProduct.siteId}`
                )
            ).then(res => {
                const mapUpdatedProducts = toLoadPricesFor.reduce((updatedProducts, item) => {
                    item.availability = res.data.availability[item.partNum];
                    item.howToBuyShowing = res.data.howToBuyShowing[item.partNum];
                    item.prices = res.data.prices[item.partNum];
                    updatedProducts[item.partNum] = item;
                    return updatedProducts;
                }, {});
                actions.changeProductsData(mapUpdatedProducts);
            });
        },
        loadMore: () => state => ({ ...state, currentPage: state.currentPage + 1 }),
        ...resolutionActions,
        ...fdActions,
        startLoadingImages: () => state => ({ ...state, loadImages: true }),
    };

    const Image = ({ src, alt, load }) => (
        <div class="product-card__image">{load ? <img src={src} loading='lazy' alt={alt} /> : null}</div>
    );

    /**
     * @typedef {Object} Props
     * @property {OptionItem} product
     */
    /**
     * @param {Props} param0
     */
    const Product = ({ product }) => (_state, actions) => (
        <div
            class="product-card"
            data-item-name={product.productDisplayNameTag}
            data-product-id={product.productId}
            data-price-no-tax={product.prices && product.prices.activePriceNoTax}
            data-price-value={product.prices && product.prices.activePriceValue}
            data-product-discount={product.prices && +Boolean(product.prices.previousPrice)}
        >
            <Image
                src={product.imageUrl}
                alt={
                    product.defaultImage
                        ? dataProduct.noProductImageLabel
                        : product.productDisplayName
                }
                load={_state.loadImages}
            />
            <div class="product-card__description">
                <div class="product-card__title">
                    <a
                        class="external-link"
                        target="_blank"
                        href={product.productPageUrl}
                        rel="noopener nofollow noreferrer"
                    >
                        {product.productDisplayName}
                    </a>
                </div>
                <div class="product-card__overview">{product.description}</div>
                <div class="product-card__sku">{product.partNum}</div>
            </div>
            <div class="product-card__info">
                {!product.availability ? (
                    <div class="wrapper-skeleton">
                        <div
                            style="width: 70px; height:18px; margin-bottom: 5px;"
                            class="template-skeleton"
                        >
                            <div class="new-skeleton" />
                        </div>
                        <div
                            style="width: 70px; height:23px; margin-bottom: 10px;"
                            class="template-skeleton"
                        >
                            <div class="new-skeleton" />
                        </div>
                        <div
                            style="width: 100%; height:30px; margin-bottom: 10px;"
                            class="template-skeleton"
                        >
                            <div class="new-skeleton" />
                        </div>
                    </div>
                ) : null}
                {product.prices ? (
                    <div class="product-card__prices">
                        {product.prices.previousPrice ? (
                            <div class={'product-card__price product-card__price_has-sale'}>
                                {product.prices.previousPrice}
                            </div>
                        ) : null}

                        {product.prices.activePrice ? (
                            <div class="product-card__price">{product.prices.activePrice}</div>
                        ) : null}
                        {product.prices.VATInclused ? (
                            <div class="vat-price-label">{dataProduct.priceWithVat}</div>
                        ) : null}
                    </div>
                ) : null}

                <div class={`${product.status === WEBDATA.LOADING ? 'btn_loading' : ''}`}>
                    {(product.availability === ADD_TO_CART ||
                        product.availability === PURCHASE_CD) && (
                        <button
                            class="product-card__button btn-se btn-se_color_blue"
                            onclick={() => actions.addToCart(product)}
                        >
                            {dataProduct.msgAddToCartText}
                        </button>
                    )}
                    {product.howToBuyShowing === true &&
                        product.availability !== ADD_TO_CART &&
                        product.availability !== DOWNLOAD &&
                        product.availability !== PURCHASE_CD && (
                            <div class="how-to-buy">
                                <a
                                    class="how-to-buy__button"
                                    href={`${dataProduct.homeLink}how-to-buy/index.jsp`}
                                    target="_blank"
                                    rel="noreferrer noopener nofollow"
                                >
                                    {dataProduct.howToBuy}
                                </a>
                            </div>
                        )}
                </div>
            </div>
        </div>
    );

    function selectProductsForRender(products, page) {
        return isNotDesktop()
            ? products.filter((item, i) => i < PAGE_SIZE * page)
            : products.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    }

    function shouldShowDropdown(list) {
        return Boolean(list) && list.length > 0;
    }

    function getDataForRender(state) {
        const { categories: actualCategories } = state;
        const selectedCategory = state.allCategoriesDD.value;
        // eslint-disable-next-line prefer-const
        let filterFunctions = [() => true];
        if (selectedCategory && selectedCategory.title !== getProductData().allCategory) {
            filterFunctions.push(item => item.category === selectedCategory.title);
        }
        const selectedSubCategory = state.allSubCategoriesDD.value;
        if (
            selectedSubCategory &&
            selectedSubCategory.title !== getProductData().allSubCategories
        ) {
            filterFunctions.push(item => item.subCategory === selectedSubCategory.title);
        }
        const actualSubCategories = selectedCategory ? selectedCategory.subCategories : null;
        const filteredProduct = state.data.filter(item => filterFunctions.every(fn => fn(item)));
        return [filteredProduct, actualCategories, actualSubCategories];
    }
    const keyDropCat = miniID();
    const keyDropSub = miniID();

    return new Promise(resolve => {
        const view = (state, actions) => {
            const counter =
                (state.allCategoriesDD.selected && 1) + (state.allSubCategoriesDD.selected && 1);

            const [filteredProduct, actualCategories, actualSubCategories] = getDataForRender(
                state
            );

            const lastItem = state.currentPage * PAGE_SIZE;
            const renderedProducts = selectProductsForRender(filteredProduct, state.currentPage);
            actions.loadPriceCurrentProducts(renderedProducts);
            return (
                <div
                    oncreate={() => {
                        appendShowMore([el]);
                        // eslint-disable-next-line
                        const unsubscribe = onScroll(shouldLoadImage);
                        function shouldLoadImage() {
                            if (el.getBoundingClientRect().top < window.innerHeight + 400) {
                                unsubscribe();
                                actions.startLoadingImages();
                            }
                        }
                        shouldLoadImage();
                        resolve();
                    }}
                >
                    <FiltersDropdown
                        {...state.filterDropdown}
                        {...actions.filterDropdown}
                        counter={counter}
                        headline={dataProduct.filterText}
                    >
                        {shouldShowDropdown(actualCategories) ? (
                            <Dropdown
                                key={keyDropCat}
                                items={actualCategories}
                                {...state.allCategoriesDD}
                                {...actions.allCategoriesDD}
                                onSelect={e => {
                                    actions.allSubCategoriesDD.setSelectedElement(0);
                                    actions.allSubCategoriesDD.setValue(
                                        e.subCategories && e.subCategories[0]
                                    );
                                    actions.setCurrentPage({ value: 1 });
                                    const showMoreElement = el.querySelector('.tabs-show-more');
                                    if (showMoreElement) {
                                        removeShowMore(showMoreElement);
                                    }
                                }}
                                label={dataProduct.filterCategory}
                                disabled={actualCategories.length === 1}
                                hide={tabName === 'service' && actualCategories.length === 1}
                            />
                        ) : null}
                        {shouldShowDropdown(actualSubCategories) ? (
                            <Dropdown
                                key={keyDropSub}
                                items={actualSubCategories}
                                {...state.allSubCategoriesDD}
                                {...actions.allSubCategoriesDD}
                                onSelect={() => {
                                    actions.setCurrentPage({ value: 1 });
                                    const showMoreElement = el.querySelector('.tabs-show-more');
                                    if (showMoreElement) {
                                        removeShowMore(showMoreElement);
                                    }
                                }}
                                hidden={
                                    !isNotDesktop() && actualCategories.length !== 1
                                        ? state.allCategoriesDD.selected === 0
                                        : false
                                }
                                label={dataProduct.filterSubCategory}
                                disabled={actualSubCategories.length === 1}
                            />
                        ) : null}
                    </FiltersDropdown>
                    <div>
                        {renderedProducts.map(
                            product => (
                                <Product key={product.skuId} product={product} />
                            ),
                            state
                        )}
                    </div>
                    <div class="option-bottom-bar">
                        <Desktop
                            render={isDesktop =>
                                isDesktop && filteredProduct.length > 5 ? (
                                    <Pagination
                                        items={filteredProduct}
                                        pageNumber={state.currentPage}
                                        setPage={value =>
                                            actions.setCurrentPage({
                                                value,
                                                shouldBeScrolled: true,
                                            })
                                        }
                                    />
                                ) : (
                                    <div />
                                )
                            }
                        />
                        <Desktop
                            render={isDesktop =>
                                isDesktop || renderedProducts.length === filteredProduct.length ? (
                                    <div />
                                ) : (
                                    <div class="load-more">
                                        <button
                                            onclick={actions.loadMore}
                                            class="btn-se btn-se_full-width btn-se_color_blue load-more__button"
                                        >
                                            {dataProduct.loadMore}
                                        </button>
                                        <div class="load-more__text">
                                            {readPagination(dataProduct.paginationTemplate, {
                                                first: 1,
                                                last:
                                                    lastItem < filteredProduct.length
                                                        ? lastItem
                                                        : filteredProduct.length,
                                                total: filteredProduct.length,
                                            })}
                                        </div>
                                    </div>
                                )
                            }
                        />
                    </div>
                </div>
            );
        };
        app(initialState, initialActions, view, rootElement);
    });
};